import { useGeneralAgentChatStore } from '../../hooks/generalAgentChatStore'
import type { PagedListCard } from '../../api/generalAgentChatApi'
import type { ListPage } from './cardResults'
import { PageFooter, type ListSubject } from './PageFooter'
import { useCardPagesStore } from './cardPagesStore'

/** The card each list subject is answered by, named as the gateway names it (the card that can read its next page). */
const CARD_OF: Record<ListSubject, PagedListCard> = { loads: 'tms_loads.list', invoices: 'tms_invoices.list' }

interface CardPageFooterProps {
    cardId?: string
    page?: ListPage
    subject: ListSubject
    /** Rows the answer holds but does not draw yet: the control reveals them before it reads a server page. */
    localHidden?: number
    onRevealLocal?: () => void
}

/** A list card's footer, wired to read its next page into the same block. */
export const CardPageFooter = ({ cardId, page, subject, localHidden, onRevealLocal }: CardPageFooterProps) => {
    const tabId = useGeneralAgentChatStore((s) => s.tabId)
    const state = useCardPagesStore((s) => (cardId ? s.byCard[cardId] : undefined))
    const loadMore = useCardPagesStore((s) => s.loadMore)
    const canLoad = !!tabId && !!cardId && !!page?.query
    return (
        <PageFooter
            page={page}
            pending={state?.pending}
            error={state?.error}
            localHidden={localHidden}
            onRevealLocal={onRevealLocal}
            onLoadMore={canLoad && page && cardId ? () => void loadMore(tabId, cardId, CARD_OF[subject], page) : undefined}
        />
    )
}
